import React, { Component } from 'react';
import { Tabs } from 'antd';

import ProgrammeForm from './components/ProgrammeForm/ProgrammeForm';
import ProgrammeInsight from './components/ProgrammeInsight/ProgrammeInsight';

const TabPane = Tabs.TabPane;

export class ProgrammeManagementPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 'detail'
        };
    }

    componentDidMount() {
        const { location } = this.props;
        const { hash } = location;

        if (hash) {
            this.setState({ activeTab: hash.substring(1) })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { location } = this.props;
        const { hash } = location;

        if (hash !== prevProps.location.hash)
            this.setState({ activeTab: hash.substring(1) })
    }

    render() {
        const { location, history, match } = this.props;
        const { activeTab } = this.state;
        const isCreateNewProgramme = match.params.programmeId === undefined;

        return (
            <div className="ManagementPage">
                <h2>{isCreateNewProgramme ? 'Create New Programme' : 'Edit Programme'}</h2>
                <Tabs 
                    activeKey={activeTab}
                    type="card" 
                    tabBarGutter={5}
                    onChange={(key) => history.push(`${location.pathname}#${key}`)}
                >
                    <TabPane tab="Detail" key="detail">
                        <ProgrammeForm/>
                    </TabPane>
                    {
                        !isCreateNewProgramme &&
                        <TabPane tab="Insight" key="insight">
                            <ProgrammeInsight/>
                        </TabPane>
                    }
                </Tabs>
            </div>
        );
    }
}

export default ProgrammeManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProgrammeManagementPage/ProgrammeManagementPage.js